// src/services/profile.service.js
import axios from 'axios';
import { auth } from './firebase';

const api = axios.create({
  baseURL: '/api',
});

// Add auth token to requests
api.interceptors.request.use(async (config) => {
  const token = await auth.currentUser?.getIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export class ProfileService {
  static async getProfile() {
    try {
      const response = await api.get('/profile');
      console.log('API Response:', response.data); // Debug log
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        console.log('Profile not found (404)'); // Debug log
        throw error;
      }
      console.error('Error getting profile:', error);
      throw error;
    }
  }

  static async updateProfile(data) {
    try {
      const response = await api.post('/profile', data);
      console.log('Update Profile Response:', response.data); // Debug log
      return response.data;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  }
}
